import { merge } from 'lodash';
var simpleMutator = function simpleMutator(state, action) {
  return action.payload;
};
var mergeMutator = function mergeMutator(state, action) {
  return merge(state, action.payload);
};
export var simpleReducer = function simpleReducer(actionType) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var mutator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : simpleMutator;
  return (
    // eslint-disable-next-line default-param-last
    function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      if (action.type === actionType) {
        return mutator(state, action);
      }
      return state;
    }
  );
};
export var mergeReducer = function mergeReducer(actionType, initialState) {
  return simpleReducer(actionType, initialState, mergeMutator);
};